import { Component, OnInit } from '@angular/core';
import { Product } from '@app/model/product'; 
import { PaymentService } from '@app/services/Payment/payment.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

  product!: Product;
  items: any = [];

  constructor(private cartService: PaymentService) { }
  ngOnInit() {
    this.fetchCart();
  } 

  fetchCart(){
    
    this.items = this.cartService.getItems();
    //this.items = JSON.stringify(this.products)

    console.log(this.items);
    // for (var i = 0; i < this.items; i++) {
    //   console.log(this.items[i]);
    //   debugger
    // }
    debugger
  }

  deleteItem(item:any){
    this.cartService.deleteItem(item);
    let domItem = document.getElementById(`cart-item`+item.product.sellProductInfoId);
    setTimeout(() =>{
    //domItem.classList.add('delete-style');
   // domItem.parentNode.removeChild(domItem);
    },1000);

  }
  
  addQty(item:any){
    this.cartService.addQty(item);
  }
}